import type { Variant } from 'components/Toolkit/Inputs/types';
import { Select } from 'components/Toolkit/Inputs/Select';

export type ListSingleSelectOption = {
  value: string;
  label: string;
};

export interface IListSingleSelectProps {
  name: string;
  label: string;
  value: string;
  options: ListSingleSelectOption[];
  onChange: (value: string) => void;
  styleVariant?: Variant;
  className?: string;
}

function ListSingleSelect({
  options,
  label,
  name,
  styleVariant = 'COMFORT',
  className,
  onChange,
  value,
}: IListSingleSelectProps) {
  return (
    <>
      {options && (
        <Select
          label={label}
          variant={styleVariant}
          className={className}
          onChange={onChange}
          name={name}
          value={value}
          options={options}
        />
      )}
    </>
  );
}

export { ListSingleSelect };
